<template>
    <v-container fluid>
        <!--<v-btn
            :loading="incidentsWithInfo === null"
            @click="newIncident"
            bottom
            color="secondary darken-1"
            fab
            fixed
            right
            class="mb-10"
        >
            <v-icon>mdi-plus</v-icon>
        </v-btn>-->
        <v-row
            align="center"
            no-gutters
        >
            <v-col
                cols="12"
                justify="center"
                lg="4"
                sm="6"
            >
                <v-subheader>
                    <h2>Incidents ({{totalMatches}})</h2>
                </v-subheader>
            </v-col>
            <v-col
                cols="12"
                lg="4"
                sm="6"
            >
                <v-text-field
                    @click:clear="setSearch('')"
                    @input="setSearch"
                    clearable
                    label="Search"
                    prepend-icon="mdi-magnify"
                    single-line
                />
            </v-col>
            <v-col
                class="text-right"
                cols="12"
                lg="4"
                sm="6"
            >
                <v-btn
                    @click="showFilters = !showFilters"
                    color="secondary darken-1"
                    icon
                >
                    <v-icon>mdi-tune</v-icon>
                </v-btn>
            </v-col>
        </v-row>
        <v-container class="pb-10">
            <v-row
                justify="center"
                v-if="incidentsWithInfo === null"
            >
                <v-col
                    :key="i"
                    cols="12"
                    lg="6"
                    v-for="i in 6"
                >
                    <v-skeleton-loader
                        elevation="4"
                        type="card"
                    ></v-skeleton-loader>
                </v-col>
            </v-row>
            <v-row
                justify="center"
                v-else
            >
                <v-col
                    :key="incidentWithInfo.entity.id"
                    cols="12"
                    lg="6"
                    v-for="incidentWithInfo in incidentsWithInfo"
                >
                    <!--@click="loadIncidentForm(incidentWithInfo.entity)"-->
                    <v-card
                        class="incident-card fill-height"
                        elevation="4"
                        style="overflow:hidden"
                    >
                        <v-card-title>
                            <h5>#{{incidentWithInfo.entity.id}}</h5>
                        </v-card-title>
                        <v-card-subtitle>
                            {{incidentWithInfo.entity.placeOfIncident}}
                            <br />
                            {{incidentWithInfo.entity.dateOfIncident.substring(0,10)}}
                        </v-card-subtitle>

                        <div>
                            <v-card-text class="center-content pa-2">
                                <v-row justify="space-around">
                                    <v-col
                                        class="text-center"
                                        cols="6"
                                        lg="3"
                                        md="4"
                                        xl="2"
                                    >
                                        <v-card class="pa-1 ma-1 fill-height">
                                            Identity Doc
                                            <br />
                                            <h3>
                                                <v-icon
                                                    color="success"
                                                    v-if="incidentWithInfo.entity.passportDocumentId || incidentWithInfo.entity.idDocumentId"
                                                >mdi-check</v-icon>
                                                <v-icon
                                                    color="error"
                                                    v-else
                                                >mdi-close</v-icon>
                                            </h3>
                                        </v-card>
                                    </v-col>
                                    <v-col
                                        class="text-center"
                                        cols="6"
                                        lg="3"
                                        md="4"
                                        xl="2"
                                    >
                                        <v-card class="pa-1 ma-1 fill-height">
                                            Consent Form
                                            <br />
                                            <h3>
                                                <v-icon
                                                    color="success"
                                                    v-if="incidentWithInfo.entity.consentFormId"
                                                >mdi-check</v-icon>
                                                <v-icon
                                                    color="error"
                                                    v-else
                                                >mdi-close</v-icon>
                                            </h3>
                                        </v-card>
                                    </v-col>
                                    <v-col
                                        class="text-center"
                                        cols="6"
                                        lg="3"
                                        md="4"
                                        xl="2"
                                    >
                                        <v-card class="pa-1 ma-1 fill-height">
                                            Amb Report
                                            <br />
                                            <h3>
                                                <v-icon
                                                    color="success"
                                                    v-if="incidentWithInfo.entity.ambulanceReportId"
                                                >mdi-check</v-icon>
                                                <v-icon
                                                    color="error"
                                                    v-else
                                                >mdi-close</v-icon>
                                            </h3>
                                        </v-card>
                                    </v-col>
                                    <v-col
                                        class="text-center"
                                        cols="6"
                                        lg="3"
                                        md="4"
                                        xl="2"
                                    >
                                        <v-card class="pa-1 ma-1 fill-height">
                                            Accident Report
                                            <br />
                                            <h3>
                                                <v-icon
                                                    color="success"
                                                    v-if="incidentWithInfo.entity.accidentReportId"
                                                >mdi-check</v-icon>
                                                <v-icon
                                                    color="error"
                                                    v-else
                                                >mdi-close</v-icon>
                                            </h3>
                                        </v-card>
                                    </v-col>
                                    <v-col
                                        class="text-center"
                                        cols="6"
                                        lg="3"
                                        md="4"
                                        xl="2"
                                    >
                                        <v-card class="pa-1 ma-1 fill-height">
                                            Account
                                            <br />
                                            <h3>
                                                <v-icon
                                                    color="success"
                                                    v-if="incidentWithInfo.info.inAccount"
                                                >mdi-check</v-icon>
                                                <v-icon
                                                    color="error"
                                                    v-else
                                                >mdi-close</v-icon>
                                            </h3>
                                        </v-card>
                                    </v-col>
                                    <!--<v-col
                                    class="text-center"
                                    cols="6"
                                    lg="3"
                                    md="4"
                                    xl="2"
                                >
                                    <v-card class="pa-2 ma-2">
                                        License
                                        <br />
                                        <h3>
                                            <v-icon
                                                color="success"
                                                v-if="incidentWithInfo.entity.licenseDocumentId"
                                            >mdi-check</v-icon>
                                            <v-icon
                                                color="error"
                                                v-else
                                            >mdi-close</v-icon>
                                        </h3>
                                    </v-card>
                                    </v-col>-->
                                </v-row>
                            </v-card-text>
                        </div>
                        <v-card-text>
                            <v-chip
                                class="ma-1"
                                color="secondary"
                                dark
                                small
                            >
                                <v-icon
                                    left
                                    small
                                >{{incidentWithInfo.entity.vehicleType == 1 ? 'mdi-car-hatchback' : incidentWithInfo.entity.vehicleType == 2 ? 'mdi-motorbike' : 'mdi-steering'}}</v-icon>
                                {{incidentWithInfo.info.driver.firstName}} {{incidentWithInfo.info.driver.surname}}
                            </v-chip>
                            <v-chip
                                class="ma-1"
                                color="secondary"
                                dark
                                small
                            >
                                <v-icon
                                    left
                                    small
                                >
                                    {{
                                    incidentWithInfo.info.patient.isPadestrian
                                    ? 'mdi-walk'
                                    : incidentWithInfo.info.patient.isPassenger
                                    ? incidentWithInfo.info.patient.seatbelt
                                    ? 'mdi-seatbelt'
                                    : 'mdi-car-child-seat'
                                    : 'mdi-clipboard-account'
                                    }}
                                </v-icon>
                                {{ incidentWithInfo.info.patient.seat == 1 && incidentWithInfo.info.patient.isPassenger ? "(front)" : incidentWithInfo.info.patient.seat == 2 ? "(back)" : ''}}
                                {{incidentWithInfo.info.patient.firstName}} {{incidentWithInfo.info.patient.surname}}
                            </v-chip>
                            <v-chip
                                class="ma-1"
                                color="secondary"
                                dark
                                small
                            >
                                <v-icon
                                    left
                                    small
                                >mdi-police-badge</v-icon>
                                {{incidentWithInfo.info.sapdMetro.name}} {{incidentWithInfo.info.sapdMetro.district}}
                            </v-chip>
                            <v-chip
                                class="ma-1"
                                color="secondary"
                                dark
                                small
                            >
                                <v-icon
                                    left
                                    small
                                >mdi-plus-thick</v-icon>
                                {{incidentWithInfo.info.createdByName}} {{incidentWithInfo.info.createdBySurname}}
                            </v-chip>
                            <v-chip
                                class="ma-1"
                                color="secondary"
                                dark
                                small
                            >
                                <v-icon
                                    left
                                    small
                                >mdi-medical-bag</v-icon>
                                {{incidentWithInfo.info.providerName}}
                            </v-chip>
                        </v-card-text>
                        <v-card-text class="pt-0">
                            Patient {{incidentWithInfo.info.patient.isPassport ? "Passport" : "Id"}} number:
                            <strong>{{incidentWithInfo.info.patient.isPassport ? incidentWithInfo.info.patient.passportNumber : incidentWithInfo.info.patient.idNumber}}</strong>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
        <!--<v-dialog
            persistent
            v-model="incidentFormVisible"
            width="500px"
        >
            <incident-form
                :disciplines="incidentDisciplines"
                :incident-in="incidentFormIncident"
                :key="incidentFormKey"
                @close="closeIncidentForm"
                @deleted="deleteIncident"
                @saved="updateIncident"
            />
        </v-dialog>-->
        <v-dialog
            transition="scroll-x-reverse-transition"
            v-model="showFilters"
            width="350px"
        >
            <v-card>
                <v-card-title>Incident Filtering</v-card-title>
                <v-card-text>
                    <v-switch
                        @change="paginationDebounce(filterDebounceTime)"
                        class="my-0"
                        label="In Account"
                        v-model="filterInAccount"
                    ></v-switch>
                    <v-radio-group
                        :column="false"
                        :disabled="!filterInAccount"
                        @change="paginationDebounce(filterDebounceTime)"
                        class="my-0"
                        v-model="filterAccount"
                    >
                        <v-radio
                            :value="true"
                            label="Yes"
                        ></v-radio>
                        <v-radio
                            :value="false"
                            class="ml-5"
                            label="No"
                        ></v-radio>
                    </v-radio-group>
                    <v-divider></v-divider>
                    <v-switch
                        @change="paginationDebounce(filterDebounceTime)"
                        class="mb-0"
                        label="Is Complete"
                        v-model="filterIsComplete"
                    ></v-switch>
                    <v-radio-group
                        :column="false"
                        :disabled="!filterIsComplete"
                        @change="paginationDebounce(filterDebounceTime)"
                        class="my-0"
                        v-model="filterComplete"
                    >
                        <v-radio
                            :value="true"
                            label="Yes"
                        ></v-radio>
                        <v-radio
                            :value="false"
                            class="ml-5"
                            label="No"
                        ></v-radio>
                    </v-radio-group>
                    <v-divider></v-divider>
                    <v-switch
                        @change="paginationDebounce(filterDebounceTime)"
                        class="mb-0"
                        label="Ageing days"
                        v-model="filterOnAgeing"
                    ></v-switch>
                    <v-select
                        :disabled="!filterOnAgeing"
                        :items="ageingOptions"
                        @change="paginationDebounce(filterDebounceTime)"
                        class="my-0"
                        item-text="name"
                        item-value="value"
                        style="max-width:200px"
                        v-model="filterAgeing"
                    ></v-select>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        @click="resetFilters"
                        class="text-none"
                        color="secondary darken-1"
                        text
                    >Reset</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="showFilters = !showFilters"
                        class="text-none"
                        color="secondary darken-1"
                        text
                    >Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-pagination
            :length="pagesCount"
            @input="paginationDebounce(500, true)"
            class="pagination-bar base-background"
            total-visible="7"
            v-model="pageNo"
            v-show="pagesCount > 1"
        ></v-pagination>
    </v-container>
</template>

<script>
//import Incident from "../models/Incident.model";
import uuid4 from "../helpers/uuid4";

export default {
    name: "Incidents",
    props: ["ageing", "inAccount", "isComplete"],
    data: function() {
        return {
            //main data
            incidentsWithInfo: null,
            //pagination
            pageNo: 1,
            pageSize: 6,
            pagesCount: 0,
            totalMatches: null,
            searchString: "",
            orderBy: "",
            sortOrder: null,
            paginationTimeout: null,
            requestId: uuid4(),
            //form data
            //incidentFormVisible: false,
            //incidentFormKey: 0,
            //incidentFormIncident: new Incident()
            //filters
            showFilters: false,
            filterDebounceTime: 500,
            filterInAccount: this.inAccount !== undefined,
            filterAccount: !!this.inAccount,
            filterIsComplete: this.isComplete !== undefined,
            filterComplete: !!this.isComplete,
            filterOnAgeing: this.ageing !== undefined,
            filterAgeing: isNaN(this.ageing) ? 0 : parseInt(this.ageing),
            ageingOptions: [
                { name: "Current", value: 0 },
                { name: "30", value: 1 },
                { name: "60", value: 2 },
                { name: "90", value: 3 },
                { name: "120", value: 4 },
                { name: "150", value: 5 },
                { name: "180", value: 6 },
                { name: "180+", value: 7 }
            ]
        };
    },
    mounted: function() {
        this.getIncidents();
    },
    //activated: function(){//when keep a live is brought back up},
    components: {
        //
    },
    methods: {
        getIncidents() {
            var requestId = (this.requestId = uuid4());
            this.$store
                .dispatch("deprecatedincidents/get", {
                    id: null,
                    urlParameters: {
                        pageNo: this.pageNo,
                        pageSize: this.pageSize,
                        searchString: this.searchString,
                        orderBy: this.orderBy,
                        sortOrder: this.sortOrder,
                        inAccount: this.filterInAccount
                            ? this.filterAccount
                            : null,
                        isComplete: this.filterIsComplete
                            ? this.filterComplete
                            : null,
                        agedMonths: this.filterOnAgeing
                            ? this.filterAgeing
                            : null
                    },
                    requestId: requestId
                })
                .then(incidentsResponse => {
                    if (this.requestId == incidentsResponse.requestId) {
                        this.incidentsWithInfo = incidentsResponse.data.page;
                        this.totalMatches = incidentsResponse.data.total;
                        this.pageSize = incidentsResponse.data.pageSize;
                        this.pageNo = incidentsResponse.data.pageNumber;
                        this.pagesCount = Math.ceil(
                            incidentsResponse.data.total / this.pageSize
                        );
                    }
                });
        },
        paginationDebounce(debounceTime, isPaging) {
            if (!isPaging) {
                this.pageNo = 1;
                this.pagesCount = 0;
            }
            if (this.incidentsWithInfo !== null) this.incidentsWithInfo = null;
            clearTimeout(this.paginationTimeout);
            this.paginationTimeout = setTimeout(
                this.getIncidents,
                debounceTime
            );
        },
        setSearch(value) {
            this.searchString = value;
            this.paginationDebounce(1000);
        },
        resetFilters() {
            this.filterInAccount = false;
            this.filterAccount = true;
            this.filterIsComplete = false;
            this.filterComplete = true;
            this.filterOnAgeing = false;
            this.filterAgeing = 0;
            this.paginationDebounce(0);
        }
    }
};
</script>

<style lang="stylus" scoped>
.incident-card
    /* background: linear-gradient(45deg, rgba(127,127,127,0.1), transparent,rgba(127,127,127,0.1)) */
    .center-content
        background-color: rgba(127, 127, 127, 0.15)

.pagination-bar
    // position: fixed;
    bottom: 0
    margin: auto
    left: 0
    right: 0
    padding-bottom: 0.1rem
    padding-top: 0.1rem
    /*
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    border:1px solid rgba(127, 127, 127, 0.2)
    */

.theme--light
    .base-background
        background: #FFFFFF

.theme--dark
    .base-background
        background: #121212
</style>
